import { create } from "zustand";

interface Row {
  [key: string]: unknown;
}

interface QueryResult {
  rows: Row[];
  fields: { name: string; dataTypeID: number }[];
  affectedRows?: number;
}

interface SqlDashboardState {
  currentQuery: string;
  queryResults: QueryResult | null;
  isExecuting: boolean;
  error: string | null;
  queryHistory: string[];
  sidebarRefreshTrigger: number;
  setQuery: (query: string) => void;
  setResults: (results: QueryResult | null) => void;
  setIsExecuting: (isExecuting: boolean) => void;
  setError: (error: string | null) => void;
  addToHistory: (query: string) => void;
  clearHistory: () => void;
  triggerSidebarRefresh: () => void;
}

export const useSqlDashboardStore = create<SqlDashboardState>((set) => ({
  currentQuery: "SELECT * FROM users LIMIT 10;",
  queryResults: null,
  isExecuting: false,
  error: null,
  queryHistory: [],
  sidebarRefreshTrigger: 0,
  setQuery: (currentQuery) => set({ currentQuery }),
  setResults: (queryResults) => set({ queryResults }),
  setIsExecuting: (isExecuting) => set({ isExecuting }),
  setError: (error) => set({ error }),
  addToHistory: (query) =>
    set((state) => {
      const trimmed = query.trim();
      if (!trimmed) return state;
      const newHistory = [
        trimmed,
        ...state.queryHistory.filter((q) => q !== trimmed),
      ].slice(0, 50);
      return { queryHistory: newHistory };
    }),
  clearHistory: () => set({ queryHistory: [] }),
  triggerSidebarRefresh: () =>
    set((state) => ({
      sidebarRefreshTrigger: state.sidebarRefreshTrigger + 1,
    })),
}));
